module.exports = __webpack_public_path__ + "media/fire.461ace13.mp3";